var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65647 7.15058C9.65974 7.03333 10.4604 8.04837 11.3984 9.58935C12.3364 11.1303 13.3581 11.9008 13.2073 13.0063C13.0365 14.2424 11.9076 14.9861 10.9964 14.9928C9.84734 14.9995 9.174 14.2357 7.71007 14.2927C6.24614 14.3496 5.80729 15.0799 4.41036 14.9928C3.38192 14.9292 2.62483 13.7031 2.68178 12.9159C2.73873 12.1286 3.12733 11.3481 3.97152 10.2493C4.81571 9.1505 5.65655 7.26448 7.65647 7.15058Z",
    stroke: "#1B2646",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77024 8.10546C3.6369 7.82701 4.07062 6.76448 3.73897 5.73224C3.40732 4.69999 2.43589 4.08892 1.56923 4.36737C0.702569 4.64582 0.268855 5.70835 0.600504 6.74059C0.932154 7.77284 1.90358 8.38391 2.77024 8.10546Z",
    stroke: "#1B2646",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.191 9.60837C16.8795 8.77095 16.8678 7.62344 16.1647 7.04533C15.4616 6.46722 14.3334 6.67743 13.6449 7.51485C12.9563 8.35227 12.9681 9.49978 13.6712 10.0779C14.3743 10.656 15.5024 10.4458 16.191 9.60837Z",
    stroke: "#1B2646",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77208 5.65644C7.83961 5.65644 8.70501 4.61406 8.70501 3.32822C8.70501 2.04238 7.83961 1 6.77208 1C5.70456 1 4.83916 2.04238 4.83916 3.32822C4.83916 4.61406 5.70456 5.65644 6.77208 5.65644Z",
    stroke: "#1B2646",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5466 5.0159C14.0065 3.84289 13.6169 2.59309 12.6764 2.22437C11.736 1.85566 10.6008 2.50767 10.1409 3.68067C9.681 4.85367 10.0706 6.10348 11.0111 6.47219C11.9515 6.84091 13.0867 6.1889 13.5466 5.0159Z",
    stroke: "#1B2646",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetsDark);
export default __webpack_public_path__ + "static/media/pets-dark.d0359e5a4e91ef8df3aefff175ce4c0e.svg";
export { ForwardRef as ReactComponent };